/** @file makeId: ULID-like `<prefix>_<26 Crockford base32 chars>` from a time and a random source. */
import { clamp } from '../math/clamp';
import { CROCKFORD_BASE32 } from './crockfordBase32';
import type { IdPrefix } from './idPrefixes';

const TIME_CHARS = 10;
const RANDOM_CHARS = 16;
const MAX_TIME = 2 ** 48 - 1;

/**
 * New id: 10 chars of `now` (ms, clamped to 48 bits, so ids sort by time) then 16 chars drawn from `random` (in [0, 1)).
 * Time and randomness are inputs so callers stay deterministic.
 */
export function makeId(prefix: IdPrefix, now: number, random: () => number): string {
  let t = clamp(Math.floor(now), 0, MAX_TIME);
  let time = '';
  for (let i = 0; i < TIME_CHARS; i++) {
    time = CROCKFORD_BASE32.charAt(t % 32) + time;
    t = Math.floor(t / 32);
  }
  let rand = '';
  for (let i = 0; i < RANDOM_CHARS; i++) rand += CROCKFORD_BASE32.charAt(clamp(Math.floor(random() * 32), 0, 31));
  return `${prefix}_${time}${rand}`;
}
